export function getRandomInt(max: number) {
  const random = Math.pow(Math.random(), 2);
  return Math.floor(random * max);
}

export function getRandomOpacity() {
  const percentage = 20 + getRandomInt(70);
  const fullRange = (255 * percentage) / 100;
  return Math.floor(fullRange).toString(16);
}

export function generateOpacityMatrix(columns: number, rows: number) {
  return Array.from({ length: columns }).map(() =>
    Array.from({ length: rows }).map(() => getRandomOpacity()),
  );
}

export const animatedBackgroundGridSize = 14;
